import { Link } from 'react-router-dom';

function ProjectItem({ id, image, title }) {
    return (
        <div className="project-item">
            <Link to={`/project/${id}`} className="project-link">
                <div className="project-image-wrapper">
                    <img
                        src={image}
                        alt={title}
                        loading="lazy"
                    />
                </div>
                <div className="project-info">
                    <p className="project-title">{title}</p>
                </div>
            </Link>
        </div>
    );
}

export default ProjectItem;